module.exports = __webpack_public_path__ + "img/Hunter-tauren-m-70.fe38850c.gif";